import { $, $$, insertHTML } from '../../../shared/js/utils/dom';
import { playerInstances } from '../../1-molecules/player/player';
import { lightboxInstances as mediaGalleryLightboxInstances } from '../../1-molecules/media-gallery/media-gallery';
import { lightboxInstances as textmediaLightboxInstances } from '../../1-molecules/textmedia/textmedia';

const docLang = document.documentElement.lang;
const lang = docLang.length > 2 ? docLang.substring(0, 2) : docLang;
const labels = {
  active: {
    de: 'aktiv',
    en: 'active',
  },
};
const lightboxInstances = [
  ...mediaGalleryLightboxInstances,
  ...textmediaLightboxInstances,
];

// toggle dark and eco mode
const switchButtons = [
  ...$$('.switch-button[data-mode="dark"]'),
  ...$$('.switch-button[data-mode="eco"]'),
];

class SwitchButton {
  constructor(props) {
    this.button = props.button;
    this.tooltipText = $('.styled-link__text', this.button);
    this.mode = this.button.getAttribute('data-mode');
    this.darkModeIsActive = localStorage.getItem('dark-mode-active') === 'true';
    this.ecoModeIsActive = localStorage.getItem('eco-mode-active') === 'true';
  }

  activateDarkMode = button => {
    this.syncButtons(button, !this.darkModeIsActive);
    localStorage.setItem(`dark-mode-active`, true);
    this.darkModeIsActive = true;
    this.toggleTheme();
  };

  activateEcoMode = button => {
    this.syncButtons(button, !this.ecoModeIsActive);
    localStorage.setItem(`eco-mode-active`, true);
    this.ecoModeIsActive = true;
    this.toggleTheme();
  };

  toggleDarkMode = e => {
    this.syncButtons(e.currentTarget, this.darkModeIsActive);
    this.darkModeIsActive
      ? localStorage.removeItem(`dark-mode-active`)
      : localStorage.setItem(`dark-mode-active`, true);
    this.darkModeIsActive = !this.darkModeIsActive;
    this.ecoModeIsActive = localStorage.getItem(`eco-mode-active`) === 'true';
    this.toggleTheme();
  };

  toggleEcoMode = e => {
    this.syncButtons(e.currentTarget, this.ecoModeIsActive);
    this.ecoModeIsActive
      ? localStorage.removeItem(`eco-mode-active`)
      : localStorage.setItem(`eco-mode-active`, true);
    this.ecoModeIsActive = !this.ecoModeIsActive;
    this.darkModeIsActive = localStorage.getItem(`dark-mode-active`) === 'true';
    this.toggleTheme();
    this.toggleMedia(this.ecoModeIsActive);
  };

  toggleMedia = ecoModeIsActive => {
    // deactivate images, iframes, sources
    const sources = [...$$('img'), ...$$('source'), ...$$('iframe')];
    if (ecoModeIsActive) {
      sources.forEach(source => {
        if (source.hasAttribute('srcset')) {
          source.removeAttribute('srcset');
        } else {
          source.removeAttribute('src');
        }
      });

      // destroy player
      playerInstances.length &&
        playerInstances.forEach(player => {
          player.destroy();
        });

      // destroy lightboxes
      lightboxInstances.length &&
        lightboxInstances.forEach(lightbox => {
          lightbox.destroy();
          const toggle = $(
            '[class*="lightbox-toggle"]',
            lightbox.config.gallery
          );
          toggle.disabled = true;
        });

      // render placeholder images
      document.body.setAttribute('data-eco-mode', ecoModeIsActive);
    } else {
      // re-enable images, iframes
      sources.forEach(source => {
        if (source.dataset.srcset) {
          source.setAttribute('srcset', source.dataset.srcset);
        } else {
          source.setAttribute('src', source.dataset.src);
        }
      });

      // init player
      playerInstances.length &&
        playerInstances.forEach(player => player.init());

      // init lightbox
      lightboxInstances.length &&
        lightboxInstances.forEach(lightbox => {
          lightbox.init();
          const toggle = $(
            '[class*="lightbox-toggle"]',
            lightbox.config.gallery
          );
          toggle.removeAttribute('disabled');
        });

      // remove placeholder images
      document.body.setAttribute('data-eco-mode', ecoModeIsActive);
    }
  };

  toggleTheme = () => {
    if (this.darkModeIsActive || this.ecoModeIsActive) {
      document.body.setAttribute('data-theme', 'dark');
    } else {
      document.body.removeAttribute('data-theme');
    }
  };

  syncButtons = (button, isPressed) => {
    const mode = button.dataset.mode;
    const buttonToBeSynced = $$(`[data-mode=${mode}]`).filter(
      item => item !== button
    );
    button.setAttribute('aria-pressed', !isPressed);
    buttonToBeSynced[0].setAttribute('aria-pressed', !isPressed);
    if (!isPressed) {
      insertHTML(
        this.tooltipText,
        'beforeend',
        ` <span class="styled-link__tooltip-state">${labels.active[lang]}</span>`
      );
    } else {
      $('.styled-link__tooltip-state', this.button).remove();
    }
  };

  bindEvents = () => {
    if (this.mode === 'dark') {
      this.button.addEventListener('click', this.toggleDarkMode);
    } else if (this.mode === 'eco') {
      this.button.addEventListener('click', this.toggleEcoMode);
    }
  };

  checkStorage = () => {
    if (this.darkModeIsActive && this.mode === 'dark') {
      this.activateDarkMode(this.button);
    } else if (this.ecoModeIsActive && this.mode === 'eco') {
      this.activateEcoMode(this.button);
      this.toggleMedia(true);
    }
  };

  init = () => {
    this.checkStorage();
    this.bindEvents();
  };
}

switchButtons.length &&
  switchButtons.forEach(button => {
    new SwitchButton({
      button,
      mode: button.dataset.mode,
    }).init();
  });

// increase font-size
const zoomButtons = $$('.switch-button[data-mode="zoom"]');

class ZoomButton {
  constructor(props) {
    this.button = props.button;
    this.tooltipText = $('.styled-link__text', this.button);
    this.zoomModeLevel = parseInt(localStorage.getItem('zoom-mode-level')) || 0;
  }

  activateZoomMode = button => {
    this.syncButtons(button, this.zoomModeLevel !== 0, this.zoomModeLevel);
    localStorage.setItem(`zoom-mode-level`, this.zoomModeLevel);
    if (this.zoomModeLevel === 1) {
      document.documentElement.style.fontSize = '1.15rem';
      document.body.setAttribute('data-zoom-mode', this.zoomModeLevel);
    } else if (this.zoomModeLevel === 2) {
      document.documentElement.style.fontSize = '1.3rem';
      document.body.setAttribute('data-zoom-mode', this.zoomModeLevel);
    }
  };

  setZoomStep = e => {
    if (!this.zoomModeLevel) {
      localStorage.setItem('zoom-mode-level', 1);
      this.syncButtons(e.currentTarget, true, 1);
      document.documentElement.style.fontSize = '1.15rem';
      this.zoomModeLevel = 1;
      document.body.setAttribute('data-zoom-mode', this.zoomModeLevel);
    } else if (this.zoomModeLevel === 1) {
      localStorage.setItem('zoom-mode-level', 2);
      this.syncButtons(e.currentTarget, true, 2);
      document.documentElement.style.fontSize = '1.3rem';
      this.zoomModeLevel = 2;
      document.body.setAttribute('data-zoom-mode', this.zoomModeLevel);
    } else if (this.zoomModeLevel === 2) {
      localStorage.removeItem('zoom-mode-level');
      this.syncButtons(e.currentTarget, false, 0);
      document.documentElement.style = '';
      document.body.removeAttribute('data-zoom-mode');
      this.zoomModeLevel = 0;
    }
  };

  syncButtons = (button, isPressed, zoomStep) => {
    const mode = button.dataset.mode;
    const buttonToBeSynced = $$(`[data-mode=${mode}]`).filter(
      item => item !== button
    );
    const tooltipState = $('.styled-link__tooltip-state', this.button);
    button.setAttribute('aria-pressed', isPressed);
    buttonToBeSynced[0].setAttribute('aria-pressed', isPressed);
    button.setAttribute('data-zoom-step', zoomStep);
    buttonToBeSynced[0].setAttribute('data-zoom-step', zoomStep);
    if (isPressed && !tooltipState) {
      insertHTML(
        this.tooltipText,
        'beforeend',
        ` <span class="styled-link__tooltip-state">${labels.active[lang]}</span>`
      );
    } else if (!isPressed && tooltipState) {
      tooltipState.remove();
    }
  };

  bindEvents = () => {
    this.button.addEventListener('click', this.setZoomStep);
  };

  checkStorage = () => {
    if (this.zoomModeLevel) {
      this.activateZoomMode(this.button);
    }
  };

  init = () => {
    this.checkStorage();
    this.bindEvents();
  };
}

zoomButtons.length &&
  zoomButtons.forEach(button => {
    new ZoomButton({
      button,
    }).init();
  });
